import React from "react";
import { EDTypography, edWebkitTheme } from "@trailblazer-game/ed-webkit";
import Stack from "@mui/material/Stack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export interface ICheckEmailUiProps {
    email: string;
    sendEmailAgain: Function;
    isLogin: boolean;
}

//
export default function CheckEmailUi(props: any) {
    let clickMsg = 'Please click the link inside to log in to your account.';

    if (props.isLogin) {
        clickMsg = 'Please click the link inside to confirm your email address.';
    }

    return (
        <Stack alignItems={"center"} justifyContent={"center"} spacing={6} sx={{ width: '300px' }}>
            <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={1}
                   sx={{ color: edWebkitTheme.palette.success.main }}>
                <CheckCircleIcon sx={{ width: '24px', marginBottom: '2px' }}/>
                <EDTypography variant={"h3"}>
                    Check Your Email
                </EDTypography>
            </Stack>
            <Stack alignItems={"center"} justifyContent={"center"} spacing={1}>
                <EDTypography variant={"body2"} align={"center"}>
                    We just sent an email to
                </EDTypography>
                <EDTypography variant={"body1"} align={"center"} sx={{ color: edWebkitTheme.palette.primary.main }}>
                    <b><i>{props.email}</i></b>.
                </EDTypography>
                <EDTypography variant={"body2"} align={"center"}>
                    {clickMsg}
                </EDTypography>
            </Stack>

            <Stack alignItems={"center"} justifyContent={"center"} spacing={1}>
                <EDTypography variant={"body1"} sx={{ color: edWebkitTheme.palette.warning.main }}>
                    Can&apos;t find it?
                </EDTypography>

                <EDTypography variant={"body2"} align={"center"}>
                    Remember to check <i>All Mail</i> or <i>Spam</i> folders, or&nbsp;
                    <a onClick={props.sendEmailAgain}>send this email again</a>
                </EDTypography>
            </Stack>
        </Stack>
    )
}